import { InputText } from "primereact/inputtext";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm, useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';

import * as myconst from "../../constants"
import { toast } from "react-toastify";
import { helperDoc } from "assets/icons";
import { InputNumber } from "primereact/inputnumber";
import { eyeIcon, CloseEyeIcon } from '../../assets/icons';


const InputDataConfiguration = ({ handleNext, methods, admin_db_config }: any) => {

    const { register, getValues, setValue, watch, formState: { errors }, control, trigger, clearErrors } = useFormContext();
    const dispatch = useDispatch();
    const fileUploadRef: any = useRef()

    const [fileUploadName, setFileUploadName] = useState<string>("")
    const [showPassword, setShowPassword] = useState(false);
    const getFormErrorMessage = (name: string) => {
        return (
            errors[name] && (
                <small className="p-error">{errors[name]?.message?.toString()}</small>
            )
        )
    }

    const handleNextButton = async () => {
        let isValid: boolean = false;
        isValid = await trigger(['host', 'port', 'username', 'password', 'dialect', 'database_name', 'table_name']);

        if (isValid) {
            handleNext();
        } else {
            const errorFields = Object.keys(errors);
            if (errorFields.length > 0) {
                const errorField = errorFields[0];
                const fieldElement = document.querySelector(`input[name=${errorField}]`);
                if (fieldElement) {
                    (fieldElement as HTMLElement)?.focus();
                } else {
                    console.warn(`Field with name ${errorField} not found`);
                }
            }
        }
    }

useEffect(()=>{


    setValue("host", admin_db_config.host);
    setValue("port", admin_db_config.port);
    setValue("username", admin_db_config.username);
    setValue("password", admin_db_config.password);
    setValue("dialect", admin_db_config.dialect);
    setValue("database_name", admin_db_config.database_name);
    setValue("table_name", admin_db_config.table_name);
    admin_db_config.file_name = admin_db_config.file_name || "";
    setValue("file_name", admin_db_config.file_name);

}, [])

    return (
        <>
            <div className="step-preview-wrap inventory-config">
                <div className='stepper-main'>
                    <div className='stepper-form'>
                        <div className='stepper-wrapper first-step-wrap'>
                            <div className='form-row'>
                                <div className='form-col'>
                                    <label className="form-label">Host<i>*</i></label>
                                    <InputText
                                        {...register("host", {
                                            required: {
                                                value: true,
                                                message: "Host is required",
                                            },
                                        })}
                                        onChange={e => { setValue("host", e.target.value); clearErrors("host") }}
                                    />
                                    {getFormErrorMessage("host")}
                                </div>
                                <div className='form-col'>
                                    <label className="form-label">Port<i>*</i></label>
                                    <Controller
                                        name="port"
                                        control={control} // Pass the control object from useForm
                                        rules={{
                                            required: {
                                                value: true,
                                                message: "Port is required",
                                            },
                                            validate: {
                                                isFourDigits: (value) => {
                                                    return /^\d{4}$/.test(value) || "Port must be exactly 4 digits";
                                                },
                                            },
                                        }}
                                        render={({ field, fieldState: { error } }) => (

                                                <InputNumber
                                                    value={field.value}  // Use field value
                                                    onChange={(e) => { field.onChange(e.value); clearErrors("port") }}  // Update field value using onChange
                                                    useGrouping={false}
                                                    min={0}
                                        
                                                />

                                        )}
                                    />
                                    {getFormErrorMessage("port")}
                                </div>
                            </div>
                            <div className='form-row'>
                                <div className='form-col'>
                                    <label className="form-label">User Name<i>*</i></label>
                                    <InputText
                                        {...register("username", {
                                            required: {
                                                value: true,
                                                message: "User Name is required",
                                            },
                                        })}
                                        onChange={e => { setValue("username", e.target.value); clearErrors("username") }}
                                    />
                                    {getFormErrorMessage("username")}
                                </div>
                                <div className='form-col'>
                                    <label className="form-label">Password<i>*</i></label>
                                    <div className="config-pass-wrap">
                                        <InputText
                                            {...register("password", {
                                                required: {
                                                    value: true,
                                                    message: "Password is required",
                                                },
                                            })}
                                            onChange={e => { setValue("password", e.target.value); clearErrors("password") }}
                                            type={showPassword ? "text" : "password"}
                                        />

                                        <span className={`password-toggle position-absolute top-50 end-0 w-auto translate-middle`} onClick={() => setShowPassword(!showPassword)}>
                                            {!showPassword ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
                                                <img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
                                            }
                                        </span>
                                    </div>
                                    {getFormErrorMessage("password")}
                                </div>
                            </div>
                            <div className='form-row'>
                                <div className='form-col'>
                                    <label className="form-label">Dialect Database<i>*</i></label>
                                    <InputText
                                        {...register("dialect", {
                                            required: {
                                                value: true,
                                                message: "Dialect Database is required",
                                            },
                                        })}
                                        onChange={e => { setValue("dialect", e.target.value); clearErrors("dialect") }}
                                    />
                                    {getFormErrorMessage("dialect")}
                                </div>
                                <div className='form-col'>
                                    <label className="form-label">Database Name<i>*</i></label>
                                    <InputText
                                        {...register("database_name", {
                                            required: {
                                                value: true,
                                                message: "Database is required",
                                            },
                                        })}
                                        onChange={e => { setValue("database_name", e.target.value); clearErrors("database_name") }}
                                    />
                                    {getFormErrorMessage("database_name")}
                                </div>
                            </div>
                            <div className='form-row'>
                                <div className='form-col'>
                                    <label className="form-label">Table Name<i>*</i></label>
                                    <InputText
                                        {...register("table_name", {
                                            required: {
                                                value: true,
                                                message: "Table name is required",
                                            },
                                        })}
                                        onChange={e => { setValue("table_name", e.target.value); clearErrors("table_name") }}
                                    />
                                    {getFormErrorMessage("table_name")}
                                </div>


                                <div className='form-col'>
                                    <label className="form-label">File Upload<i>*</i></label>
                                    <div className="form-field-wrap">
                                        <input
                                            onChange={async (e: any) => {
                                                if (e.target.files[0]) {
                                                    if (myconst.imageTypes.includes(e.target.files[0].type)) {
                                                        const base64Code: any = await myconst.fileToBase64(e.target.files[0])
                                                        const correctBase64 = await myconst.manipulateBase64Data(base64Code);
                                                        setValue("file", correctBase64);
                                                        setFileUploadName(e?.target?.files[0]?.name)
                                                    } else {
                                                        toast.error("File is not supported", {
                                                            style: {
                                                                backgroundColor: '#F1F1F1', // Grey background
                                                            }
                                                        })
                                                        fileUploadRef.current.value = ""
                                                    }
                                                }
                                            }
                                            }
                                            type="file"
                                            accept=".jpg,.png,.webp,.jpeg"
                                            ref={fileUploadRef}
                                            id="bLogo"
                                            className="d-none"
                                        />
                                        <button type="button" className="file-btn" onClick={() => fileUploadRef.current.click()}>Choose File</button>
                                        <span className="file-label" title={fileUploadName}>{fileUploadName === "" ? "No file Chosen" : fileUploadName}</span>

                                    </div>
                                    <p className='helper-text'><i><img src={helperDoc} alt='qmate-icon' /></i><b>File formats:</b> JPG, PNG, of <b>10 MB</b> in size.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='stepper-footer'>
                        <div className='stepper-wrapper stepper-wrapper-ft'>
                            <div className='stepper-footer-inner'>
                                <div className='stepper-footer-left'></div>
                                <div className='stepper-footer-right'>
                                    <button type="button" className="outline-active-btn" onClick={() => handleNextButton()}>Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InputDataConfiguration
